export class Expandable {
  expanded = false;

  toggleExpanded() {
    this.expanded = !this.expanded;
  }
}
